import React, { useEffect, useState } from 'react';

import AddStationModal from '../components/ModalAddStation';
import {
  getUsers,
  getArmexStations,
  assignStationsToUser,
  getStationsArmexData,
  deleteStation,
  deleteStationStation,
  updateArmexStationsOnBackend,
  assignNearbyStation,
  SetStationActive,
  limitsSend,
  toggleStationPriceType
} from '../api_controll/apiAdmin';
import BackButton from '../components/BackButton';

import { useCallback, useMemo } from 'react';
import { debounce } from 'lodash';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { can } from "../auth/can";
import { PERMS } from "../auth/permissions";

export default function AdminStationPage(){

  const [users, setUsers] = useState([]);
  const [stationsArmex, setStationsArmex] = useState([]);
  const [addingStationUserId, setAddingStationUserId] = useState(null);
  const [addingStationToStation, setAddingStationToStation] = useState(null);
  const [addingNONEStationToStation, setAddingNONEStationToStation] = useState(null);

  const [newStationToStation, setNewStationToStation] = useState({
    stationId: '',
    noneArmexStationId: '',
    nonearmexstation_name: '',
    armex_name: '',
  });
  const [newStationAssignment, setNewStationAssignment] = useState({ userId: '', stationId: '', username: '' });

  const [stations, setStations] = useState([]);
  const [connectedUsers, setConnectedUsers] = useState({});
  const [connectedStations, setConnectedStations] = useState({});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [editingStationId, setEditingStationId] = useState(null);
  const [editedValues, setEditedValues] = useState({});

  const [searchTerm, setSearchTerm] = useState('');
const [filter, setFilter] = useState('all');
const [statusFilter, setStatusFilter] = useState('active');    // all | active | inactive

const [editedLimits, setEditedLimits] = useState({});
const [inputCache, setInputCache] = useState({});

const [editingNonArmexId, setEditingNonArmexId] = useState(null);
const [editedNonArmexValues, setEditedNonArmexValues] = useState({});

const [selectedArmexStation, setSelectedArmexStation] = useState(null);
  const user = useSelector(state => state.user.user);

  const [priceTypesCatalog, setPriceTypesCatalog] = useState([]);
  const LIMITS_EXCLUDED = new Set(["Kurz", "TF cig", "TF zboží"]);


  const canDisplayStation = useMemo(() => can(user, PERMS.STATION_ADMIN_PANEL), [user]);
  const canEditNearby = useMemo(() => can(user, PERMS.NEARBY_STATION_EDIT), [user]);
  const canEditArmex = useMemo(() => can(user, PERMS.ARMEX_STATION_EDIT), [user]);
  const canPairNearbyToArmex = useMemo(() => can(user, PERMS.NEARBY_STATION_PAIR), [user]);
  const canAddUsertoStation = useMemo(() => can(user, PERMS.STATION_USER_ASSIGN), [user]);
  const canEditandDisplayLimits = useMemo(() => can(user, PERMS.STATION_LIMITS_EDIT_DISPLAY), [user]);
  const canAddStation = useMemo(() => can(user, PERMS.ADD_STATION), [user]);
  const canDeactivateStation = useMemo(() => can(user, PERMS.STATION_DEACTIVATE), [user]);

  useEffect(() => {
    async function fetchAllData() {
      try {
        if (!canDisplayStation) return;

        const usersData = await getUsers();
        const bundle = await getStationsArmexData(); // { price_types, armex_stations, none_armex_stations }

        setPriceTypesCatalog(bundle?.price_types || []);

        const normalizeStation = (st) => {
          let pts = st?.price_types;

          // pojistka: kdyby někde pořád přišel string
          if (typeof pts === "string") {
            try { pts = JSON.parse(pts); } catch { pts = []; }
          }
          if (!Array.isArray(pts)) pts = [];

          return { ...st, price_types: pts };
        };

        const allStationsFlat = [
          ...(bundle?.armex_stations || []).map(normalizeStation),
          ...(bundle?.none_armex_stations || []).map(normalizeStation),
        ];

        setStations(allStationsFlat);

        const stationDataArmexOnly = await getArmexStations();
        setStationsArmex(stationDataArmexOnly);
        setUsers(usersData);

        setConnectedStations({});
        setConnectedUsers({});
      } catch (err) {
        console.error(err);
        toast.error("Nepodařilo se načíst data.");
      } finally {
        setLoading(false);
      }
    }

    fetchAllData();
  }, [canDisplayStation]);

  const stationPriceTypeMap = useMemo(() => {
  // Map: stationId -> { priceTypeId -> isEnabled }
  const map = new Map();

  for (const st of stations) {
    const sid = String(st.station_id);
    const inner = new Map();

    (st.price_types || []).forEach((pt) => {
      inner.set(String(pt.price_type_id), Boolean(pt.is_enabled));
    });

    map.set(sid, inner);
  }

  return map;
}, [stations]);



 
const handleArmexClick = (station) => {
  if (selectedArmexStation?.station_id === station.station_id) {
    setSelectedArmexStation(null); // toggle off
  } else {
    setSelectedArmexStation(station);
  }
};

function isConnected(nonArmexStation) {
  const connected = selectedArmexStation?.connected_stations;
  if (!connected || !Array.isArray(connected)) return false;

  return connected.some(
    cs => String(cs.station_id) === String(nonArmexStation.station_id)
  );
}
const handleRemoveStationUser = async (stationId, userId, userName, stationName) => {
  if (!window.confirm(`Opravdu odebrat uživatele ${userName} od ${stationName}?`)) return;

  try {
    await deleteStation(stationId);
    toast.success("Uživatel byl uspěšně odebrán!");
    // Update the stations list by removing the user from the station's connected_users
    setStations(prev =>
      prev.map(station => {
        if (station.station_id !== stationId) return station;

        return {
          ...station,
          connected_users: (station.connected_users || []).filter(user => user.user_id !== userId),
        };
      })
    );

  } catch (error) {
  
    toast.error("Chyba při odstraňování uživatele");
  }
};

      const handleRemoveStationStation = async (ArmexStationID, RemovedstationId, stationRemoved, FromStation) => {
        if (!window.confirm(`Opravdu odebrat ${stationRemoved} od ${FromStation}?`)) return;
        try {
          await deleteStationStation(ArmexStationID, RemovedstationId);
          toast.success("Stanice byla odebrána!");
       // Update connectedStations for both directions
    setConnectedStations(prev => {
      const updated = {
        ...prev,
        [ArmexStationID]: (prev[ArmexStationID] || []).filter(
          s => Number(s.station_id) !== Number(RemovedstationId)
        ),      
      };

   

      return updated;
    }
  );

    // Update Armex station's state
    setStations(prevStations =>
      prevStations.map(station => {
        if (Number(station.station_id) === Number(ArmexStationID)) {
          return {
            ...station,
            connected_stations: (station.connected_stations || []).filter(
              s => Number(s.station_id) !== Number(RemovedstationId)
            )
          };
        }
        return station;
      })
    );

    // Update non-Armex station's state (important!)
    setStations(prevStations =>
      prevStations.map(st => {
        if (Number(st.station_id) === Number(RemovedstationId)) {
          return {
            ...st,
            connected_stations: (st.connected_stations || []).filter(
              s => Number(s.station_id) !== Number(ArmexStationID)
            )
          };
        }
        return st;
      })
    );
      
        } catch (err) {
         
          toast.error("Nepodařilo se odebrat ČS.");
        }

      }

      const [ptBusy, setPtBusy] = useState({}); 
// key: `${stationId}:${priceTypeId}` => true/false

const togglePriceType = async (station, pt) => {
  const stationId = Number(station.station_id);
  const fuelId = Number(pt.id);
  const key = `${stationId}:${fuelId}`;

  if (ptBusy[key]) return;

  const currentlyEnabled = isStationPriceTypeEnabled(station, fuelId);
  const action = currentlyEnabled ? "delete" : "insert";

  // optimisticky update
  setStations(prev =>
    prev.map(s => {
      if (Number(s.station_id) !== stationId) return s;

      const list = Array.isArray(s.price_types) ? [...s.price_types] : [];
      if (action === "insert") {
        // přidat jen když tam není
        if (!list.some(x => Number(x.price_type_id) === fuelId)) {
          list.push({ price_type_id: fuelId });
        }
      } else {
        // delete
        return { ...s, price_types: list.filter(x => Number(x.price_type_id) !== fuelId) };
      }
      return { ...s, price_types: list };
    })
  );

  setPtBusy(prev => ({ ...prev, [key]: true }));

  try {
    await toggleStationPriceType({ action, station_id: stationId, fuel_id: fuelId });
    toast.success(action === "insert" ? "Povoleno" : "Zakázáno");
  } catch (e) {
    // revert (nejjednodušší: refresh, nebo ruční revert)
    toast.error("Nepodařilo se změnit price type.");
    refreshFunkce(); // pragmaticky nejlepší - db je source of truth
  } finally {
    setPtBusy(prev => ({ ...prev, [key]: false }));
  }
};
  const getStationLimitFuels = (station) => {
  const enabledIds = new Set((station.price_types || []).map(x => Number(x.price_type_id)));

  return (priceTypesCatalog || [])
    .filter(pt => pt.is_active)
    .filter(pt => enabledIds.has(Number(pt.id)))
    .filter(pt => !LIMITS_EXCLUDED.has(pt.type_name))
    .map(pt => pt.type_name); 
};

const filteredStations = stations.filter(st => {
  const name = st.station_name || st.name || '';
  const matchSearch = name.toLowerCase().includes(searchTerm.toLowerCase());

  // armex filter
  const isArmex = Number(st.is_armex) === 1;
  const matchFilter =
    filter === 'all' ||
    (filter === 'armex' && isArmex) ||
    (filter === 'non-armex' && !isArmex);


  const isActive = Boolean(st.is_active);
  const matchStatus =
    statusFilter === 'all' ||
    (statusFilter === 'active' && isActive) ||
    (statusFilter === 'inactive' && !isActive);

  return matchSearch && matchFilter && matchStatus;
});

const armexStations = filteredStations.filter(st => Number(st.is_armex) === 1);

const nonArmexStations = filteredStations
  .filter(st => Number(st.is_armex) === 0)
  .sort((a, b) => {
    const connected = selectedArmexStation?.connected_stations;
    if (!connected || !Array.isArray(connected)) return 0;
  
    const aIsConnected = connected.some(
      cs => String(cs.station_id) === String(a.station_id)
    );
    const bIsConnected = connected.some(
      cs => String(cs.station_id) === String(b.station_id)
    );
  
    return (bIsConnected ? 1 : 0) - (aIsConnected ? 1 : 0);
  });
const handleEditClick = (station) => {
  setEditingStationId(station.station_id);
  setEditedValues({
    name: station.station_name,
    location: station.location,
    armex_id: station.armex_id,
    display_euro: station.display_euro

  });
};

const handleInputChange = (e) => {
  const { name, value } = e.target;
  setEditedValues(prev => ({ ...prev, [name]: value }));
};
const stationEnabledSet = useMemo(() => {
  const map = new Map(); // stationId -> Set(priceTypeId)
  for (const st of stations) {
    const sid = String(st.station_id);
    const set = new Set((st.price_types || []).map(x => String(x.price_type_id)));
    map.set(sid, set);
  }
  return map;
}, [stations]);

const isStationPriceTypeEnabled = (station, priceTypeId) => {
  const set = stationEnabledSet.get(String(station.station_id));
  return set ? set.has(String(priceTypeId)) : false;
};

const handleSave = async (station_id) => {
  
  try {
    await updateArmexStationsOnBackend(station_id, editedValues);
    setEditingStationId(null);
     // Update stations locally
     setStations(prev => prev.map(station => 
      station.station_id === station_id
        ? { 
            ...station, 
            ...editedValues,
            station_name: editedValues.name  // overwrite with correct key
          }
        : station
    ));

    
    // If stationsArmex stores same stations, update it similarly
    setStationsArmex(prev => prev.map(station => 
      station.id === station_id 
        ? { ...station, name: editedValues.name, location: editedValues.location } 
        : station
    ));
    toast.success("Uspěšně změněno!");
    
  } catch (err) {
    
    toast.error("Chyba při ukládání změn.");
  }
};

const UserStationAssignment = async () => {
  if (!newStationAssignment.userId || !addingStationUserId) {
 
    toast.error("Vyberte uživatele a stanici!");
    return;
  }

  try {
    await assignStationsToUser({
      user_id: Number(newStationAssignment.userId),
      station_id: Number(addingStationUserId),
    });

    // Add user to station's connected_users
    setStations(prev =>
      prev.map(station =>
        station.station_id === newStationAssignment.stationId
          ? {
              ...station,
              connected_users: [
                ...(station.connected_users || []),
                {
                  id: Number(newStationAssignment.userId),
                  username: newStationAssignment.username,
                  user_id: Number(newStationAssignment.userId),
                },
              ],
            }
          : station
      )
    );

  

    setNewStationAssignment({ ArmexStationID: '', stationId: '', name: '' });
    setAddingStationUserId(null);
    toast.success("Stanice a uživatel spárováni!");
    
  } catch (err) {
   
    toast.error("Nepodařilo přidat uživatele ke stanici!");
  }
};




const toggleStationActive = async (station_id, stationName, currentIsActive) => {
  const id = Number(station_id);
  if (!Number.isFinite(id) || id <= 0) {
    toast.error("Neplatné ID stanice.");
    return;
  }

  const nextIsActive = !Boolean(currentIsActive);

  const actionText = nextIsActive ? "aktivovat" : "deaktivovat";
  const ok = window.confirm(`Opravdu chcete ${actionText} stanici ${stationName}?`);
  if (!ok) return;

  try {
    const payload = { station_id: station_id, is_active: nextIsActive };

    await SetStationActive(payload);

    toast.success(nextIsActive ? "Stanice aktivována." : "Stanice deaktivována.");
  refreshFunkce();

  } catch (err) {

    toast.error(err?.message || "Akci se nepodařilo provést.");
  }
}




const StationToStationAssignment = async () => {
  if (
    !newStationToStation.stationId ||
    !newStationToStation.noneArmexStationId 

  ) {

    toast.error("Vyberte obě stanice.");
    return;
  }
  try {
    const data = {
      baseStationId: newStationToStation.stationId,
      nearbyStationId: newStationToStation.noneArmexStationId
    };

    await assignNearbyStation(data);
   
    toast.success("Stanice přidána!");

    setStations((prev) =>
      prev.map((station) => {
        const isArmex = station.station_id === newStationToStation.stationId;
        const isNonArmex = station.station_id === newStationToStation.noneArmexStationId;
    
        if (isArmex) {
          const alreadyAssigned = (station.connected_stations || []).some(
            (s) => s.station_id === newStationToStation.noneArmexStationId
          );
    
          return {
            ...station,
            connected_stations: alreadyAssigned
              ? station.connected_stations
              : [
                  ...(station.connected_stations || []),
                  {
                    station_id: newStationToStation.noneArmexStationId,
                    name: newStationToStation.nonearmexstation_name,
                  },
                ],
          };
        }
    
        if (isNonArmex) {
          const alreadyAssigned = (station.connected_stations || []).some(
            (s) => s.station_id === newStationToStation.stationId
          );
        
          return {
            ...station,
            connected_stations: alreadyAssigned
              ? station.connected_stations
              : [
                  ...(station.connected_stations || []),
                  {
                    station_id: newStationToStation.stationId,
                    name: newStationToStation.armex_name,
                  },
                ],
          };
        }
    
        return station;
      })
    );
    // Reset form/modal
    setNewStationToStation({
      stationId: '',
      noneArmexStationId: '',
      nonearmexstation_name: '',
      armex_name: '',

    });
    setAddingStationToStation(null);
    setAddingNONEStationToStation(null);
  } catch (err) {
    console.error(err);
    
    toast.error("Nepodařilo se přiřadit stanici.");
  }
};
const refreshFunkce = async () =>{
  try {
     
    const bundle = await getStationsArmexData(); 

      const allStationsFlat = [
        ...(bundle?.armex_stations || []),
        ...(bundle?.none_armex_stations || []),
      ];

    const stationDataArmexOnly = await getArmexStations();

    setStations(allStationsFlat);
    setStationsArmex(stationDataArmexOnly);

    const usersMap = {};
    const stationsMap = {};

    
   

    setConnectedStations(stationsMap);
    setConnectedUsers(usersMap);
  } catch (err) {
    console.error(err);

    toast.error("Nepodařilo se načíst data.");
  } finally {
    setLoading(false);
  }
}

const handleNonArmexEditClick = (station) => {
  setEditingNonArmexId(station.station_id);
  setEditedNonArmexValues({
    name: station.station_name,
    location: station.location,
    display_euro: station.display_euro,
    armex_id: null
  });
};
const handleNonArmexInputChange = (e) => {
  const { name, value } = e.target;
  setEditedNonArmexValues(prev => ({ ...prev, [name]: value }));
};

const handleNonArmexSave = async (stationId) => {
  try {
   await updateArmexStationsOnBackend(stationId, editedNonArmexValues); // backend API call
   setStations(prev =>
    prev.map(st =>
      st.station_id === stationId
        ? { 
            ...st, 
            station_name: editedNonArmexValues.name, // rename 'name' to 'station_name'
            location: editedNonArmexValues.location, 
            display_euro: editedNonArmexValues.display_euro 

          }
        : st
    )
  );
  toast.success("Změny uspěšně proběhli!");
  

  setEditingNonArmexId(null);
  } catch (err) {
   
    toast.error("Chyba při ukládání změn non-Armex.");
  }
};

const getInputValue = (station, station_id, fuel, type) => {
  const cached = inputCache?.[station_id]?.[fuel]?.[type];
  if (cached !== undefined) return cached;

  const edited = editedLimits?.[station_id]?.[fuel]?.[type];
  if (edited !== undefined) return edited.toString();

  const fallback = station?.limits?.find(
    (l) => l.price_type === fuel && l.role === type
  )?.value;
  if (fallback !== undefined) return fallback.toString();

  return "";
};

const isStationActive = (st) => Boolean(Number(st?.is_active));

const debouncedLimitsSend = useCallback(
  debounce(async (params) => {
    try {
      await limitsSend(params);
      toast.success(`Nastaven ${params.fuel} ${params.type} na ${params.value}`);
    } catch (err) {
      toast.error("Nepodařilo se změnit limit.");
    }
  }, 500), 
);

const handleLimitChange = (fuel, station_id, type, numericValue) => {
  const value = numericValue === "" ? 0 : Number(numericValue);
  
  
  setEditedLimits(prev => ({
    ...prev,
    [station_id]: {
      ...prev[station_id],
      [fuel]: {
        ...prev[station_id]?.[fuel],
        [type]: value
      }
    }
  }));
  
  debouncedLimitsSend({ fuel, station_id, type, value });
};

if (!canDisplayStation) return <p className="admin-no-permission">Nemáš oprávnění pro zobrazení této stránky.</p>;
if (loading) return <p className="admin-loading">Načítání...</p>;
if (error) return <p className="admin-error">{error}</p>;

return (
  
  <div className="admin-stations-page">

    <h1 className="admin-stations-page__title">Správa Čerpacích Stanic</h1>

    <div className="admin-stations-page__controls">
      <BackButton></BackButton>
    <input
  type="text"
  placeholder="Hledat stanici..."
  className="admin-stations-page__search"
  value={searchTerm}
  onChange={e => setSearchTerm(e.target.value)}
/>

<select
  className="admin-stations-page__filter"
  value={filter}
  onChange={e => setFilter(e.target.value)}
>
  <option value="all">Všechny</option>
  <option value="armex">Pouze Armex</option>
  <option value="non-armex">Pouze Ne-Armex</option>
</select>
<div className="admin-stations-page__statusTabs">
  <button
    type="button"
    className={`statusTab ${statusFilter === 'active' ? 'is-active' : ''}`}
    onClick={() => setStatusFilter('active')}
  >
    Aktivní
  </button>

  <button
    type="button"
    className={`statusTab ${statusFilter === 'inactive' ? 'is-active' : ''}`}
    onClick={() => setStatusFilter('inactive')}
  >
    Deaktivované
  </button>

  <button
    type="button"
    className={`statusTab ${statusFilter === 'all' ? 'is-active' : ''}`}
    onClick={() => setStatusFilter('all')}
  >
    Všechny
  </button>
</div>
{canAddStation && (
  <AddStationModal
    onStationAdded={() => {
      refreshFunkce();
    }}
    existingStations={stations}
  />
)}
    </div>

    <div className="admin-stations-page__columns">
    <div className="admin-stations-armex">
  <h2 className="admin-stations-armex__title">Armex Stanice</h2>
  <div className="admin-stations-armex__list">
    {armexStations.map((station) => {
      const isEditing = editingStationId === station.station_id;
      const isAssigningUser = addingStationUserId === station.station_id;
      const isAssigningStation = addingStationToStation === station.station_id;

      const active = isStationActive(station);

      return (
        <div
        key={station.station_id}
        onClick={() => active && handleArmexClick(station)}
          className={[
            "station-card",
            selectedArmexStation?.station_id === station.station_id ? "selected" : "",
            !active ? "is-inactive" : "",
          ].join(" ")}
      >
          <div className="station-card__header">
            {isEditing ? (
              <>
                <input
                  name="name"
                  value={editedValues.name}
                  onChange={handleInputChange}
                />
               
                <input
                  name="location"
                  value={editedValues.location}
                  onChange={handleInputChange}
                />
                
              </>
            ) : (
              <>
                <h3 className="station-card__name">{station.station_name}</h3>
               
                <span className="station-card__location">{station.location}</span>
              </>
            )}
           
          </div>
 <div className="test-test">

                 {!active ? (
                    <span className="statusBadge statusBadge--inactive" title="Stanice je deaktivovaná">
                      Deaktivováno
                    </span>
                  ) : (
                    <span className="statusBadge statusBadge--active" title="Stanice je aktivní">
                      Aktivní
                    </span>
                  )}
                   </div>
                 <div className="station-card__details">
                <div>ID: {station.station_id}</div>

                <div>
                  Zobrazovat Euro:{' '}
                  {isEditing ? (
                    <select
                      name="display_euro"
                      value={editedValues.display_euro}
                      onChange={handleInputChange}
                      style={{
                        marginLeft: '8px',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        fontSize: '14px',
                      }}
                    >
                      <option value={1}>Ano</option>
                      <option value={0}>Ne</option>
                    </select>
                  ) : (
                    <strong style={{ marginLeft: '8px' }}>
                      {station.display_euro === "1" || station.display_euro === 1 ? 'Ano' : 'Ne'}
                    </strong>
                  )}
                </div>

                <div>
                   Armex ID:{' '}
                  {isEditing ? (
                                    
                    <input
                      type="number"
                      name="armex_id"
                      value={editedValues.armex_id}
                      onChange={handleInputChange}
                      style={{
                        marginTop: '8px',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        border: '1px solid #ccc',
                        fontSize: '14px',
                      }}
                    />
                    
                  ) : (
                    <strong style={{ marginLeft: '8px' }}>
                    {station.armex_id}
                    </strong>
                  )}
                </div>
              </div>

          <div className="station-card__actions">
            {canEditArmex && (
              isEditing ? (
                <>
                  <button onClick={() => handleSave(station.station_id)}>Uložit</button>
                  <button onClick={() => setEditingStationId(null)}>Zrušit</button>
                </>
              ) : (
                <button  className={!active ? "btn-disabled" : ""} onClick={() => handleEditClick(station)}>Změnit</button>
              )
            )}
            {canAddUsertoStation && (
            <button onClick={() => setAddingStationUserId(station.station_id)}>
              Přidat uživatele
            </button>
            )}
            {canPairNearbyToArmex && (
              <button
                onClick={() => {
                  setAddingStationToStation(station.station_id);
                  setNewStationToStation({
                    stationId: station.station_id,
                    noneArmexStationId: '',
                    nonearmexstation_name: '',
                  });
                }}
              >
              Přidat ČS stanice
            </button>
          )}

          </div>



          <div className="station-card__related">
        <strong>Spárované Stanice:</strong>
        <ul>
        {(armexStations.find(st => st.station_id === station.station_id)?.connected_stations || []).map(s => (
  <li key={s.station_id}>
    {s.name || s.station_name}
    {canPairNearbyToArmex && (
    <button
      className="remove-station-button"
      onClick={() => handleRemoveStationStation(station.station_id, s.station_id, s.name || s.station_name, station.station_name)}
      title="Odebrat stanici"
    >
      ✕
    </button>
    )}
  </li>
))}
        </ul>
        {isAssigningStation && (() => {
  // Get non-Armex stations that are NOT yet connected to this Armex station
  const connectedIds = (station.connected_stations || []).map(s => Number(s.station_id));
  const availableStations = nonArmexStations.filter(s => !connectedIds.includes(Number(s.station_id)));

  return (
    <div className="station-form">
      <select
        className="admin-select"
        onChange={(e) => {
          const selected = nonArmexStations.find(
            s => s.station_id.toString() === e.target.value
          );
          setNewStationToStation({
            stationId: station.station_id,
            noneArmexStationId: e.target.value,
            nonearmexstation_name: selected?.station_name || '',
            armex_name: station.station_name,

          });
        }}
        defaultValue=""
        disabled={availableStations.length === 0}
      >
        
        {availableStations.length === 0 ? (
          <option value="">-- Všechny přiřazené stanice --</option>
        ) : (
          <>
            <option value="">-- Vyber stanici --</option>
            {availableStations.map(s => (
              <option key={s.station_id} value={s.station_id}>
                {s.station_name}
              </option>
            ))}
          </>
        )}
      </select>

      <button
        className="admin-assign-button"
        onClick={StationToStationAssignment}
        disabled={availableStations.length === 0}
      >
        Přidat
      </button>
    </div>
  );
})()}

        
      </div>
          <div className="station-card__related">




            <strong>Spárovaní uživatelé:</strong>
            
            <ul>
            {(armexStations.find(st => st.station_id === station.station_id)?.connected_users || []).map(user => (
              
  <li key={user.id}>
    {user.username || user.name}
    {canAddUsertoStation && (
      <button
        onClick={() => handleRemoveStationUser(station.station_id, user.user_id, user.username, station.station_name)}
        className="remove-station-button"
        title="Odebrat uživatele"
      >
        ✕
      </button>
    )}
  </li>
))}

            </ul>


            {isAssigningUser && (() => {
  const assignedUserIds = new Set((station.connected_users || []).map(u => u.user_id));
  const usersWithoutThisStation = users.filter(u => !assignedUserIds.has(Number(u.id)));

  return (
    <div className="station-form">
      <select
        className="admin-select"
        onChange={(e) => {
          const selectedUser = usersWithoutThisStation.find(
            (u) => u.id.toString() === e.target.value
          );
          setNewStationAssignment({
            stationId: station.station_id,
            userId: e.target.value,
            username: selectedUser?.username || '',
          });
        }}
        defaultValue=""
        disabled={usersWithoutThisStation.length === 0}
      >
        {usersWithoutThisStation.length === 0 ? (
          <option value="">-- Všichni uživatelé přiřazeni --</option>
        ) : (
          <>
            <option value="">-- Vyber uživatele --</option>
            {usersWithoutThisStation.map((u) => (
              <option key={u.id} value={u.id}>
                {u.username}
              </option>
            ))}
          </>
        )}
      </select>

      <button
        className="admin-assign-button"
        onClick={UserStationAssignment}
        disabled={usersWithoutThisStation.length === 0}
      >
        Přidat
      </button>
    </div>
  );
})()}
          </div>
          <div className="station-card__priceTypes">
  <strong>Povolené zboží:</strong>

  <div className="priceTypesChips">
  {(priceTypesCatalog || [])
    .filter(pt => pt.is_active)
    .map(pt => {
      const enabled = isStationPriceTypeEnabled(station, pt.id);
      const key = `${station.station_id}:${pt.id}`;
      const busy = !!ptBusy[key];

      return (
        <button
          type="button"
          key={pt.id}
          disabled={busy}
          onClick={() => togglePriceType(station, pt)}
          className={[
            "ptChip",
            enabled ? "ptChip--on" : "ptChip--off",
            busy ? "ptChip--busy" : "",
          ].join(" ")}
          title={enabled ? "Klikni pro zakázání" : "Klikni pro povolení"}
        >
          {pt.type_name}
        </button>
      );
    })}
</div>


  {/* Bonus: sumarizace */}
  <div className="ptSummary">
    {(() => {
      const act = (priceTypesCatalog || []).filter(pt => pt.is_active);
      const enabledCount = act.filter(pt => isStationPriceTypeEnabled(station, pt.id)).length;
      return <span>{enabledCount}/{act.length} povoleno</span>;
    })()}
  </div>
</div>
          <div className='delete-station-div'>

          {canDeactivateStation && 
          <button
            className={`delete-station-btn ${active ? "btn-danger" : "btn-ok"}`}
            onClick={() => toggleStationActive(station.station_id, station.station_name, station.is_active)}
          >
            {active ? "Deaktivovat" : "Aktivovat"}
          </button>
            }
            </div>
        </div>
        

      );
      
    })}
    
  </div>
  
</div>













      <div className="admin-stations-nonarmex">
        <h2 className="admin-stations-nonarmex__title">Konkurenční Stanice</h2>
        <div className="admin-stations-nonarmex__list">
        {nonArmexStations.map(station => {
  const isEditing = editingNonArmexId === station.station_id;
  const isAssigningStationToNONEStation = addingNONEStationToStation === station.station_id;
  const active = isStationActive(station);

 
  return (
    <div
            key={station.station_id}
            className={`station-card ${isConnected(station) ? 'highlighted' : ''}`}
          >
      <div className="station-card__header">
  {isEditing ? (
    <>
      <input
        name="name"
        value={editedNonArmexValues.name}
        onChange={handleNonArmexInputChange}
        style={{
          marginBottom: '6px',
          padding: '4px 8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          fontSize: '14px',
          display: 'block',
        }}
      />

      <input
        name="location"
        value={editedNonArmexValues.location}
        onChange={handleNonArmexInputChange}
        style={{
          padding: '4px 8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          fontSize: '14px',
          display: 'block',
        }}
      />
    </>
  ) : (
    <>
      <h3 className="station-card__name">{station.station_name}</h3>
      
      <span className="station-card__location">{station.location}</span>
    </>
  )}
</div>
<div className="test-test">
   {!active ? (
          <span className="statusBadge statusBadge--inactive" title="Stanice je deaktivovaná">
            Deaktivováno
          </span>
        ) : (
          <span className="statusBadge statusBadge--active" title="Stanice je aktivní">
            Aktivní
          </span>
        )}
        </div>
<div className="station-card__details">

  <div>ID: {station.station_id}</div>

  <div style={{ marginTop: '6px' }}>
    Zobrazovat Euro:{' '}
    {isEditing ? (
      <select
        name="display_euro"
        value={editedNonArmexValues.display_euro}
        onChange={handleNonArmexInputChange}
        style={{
          marginLeft: '8px',
          padding: '4px 8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          fontSize: '14px',
        }}
      >
        <option value={1}>Ano</option>
        <option value={0}>Ne</option>
      </select>
    ) : (
      <strong style={{ marginLeft: '8px' }}>
        {station.display_euro === "1" || station.display_euro === 1 ? 'Ano' : 'Ne'}
      </strong>
    )}
  </div>
</div>

      <div className="station-card__actions">
        {isEditing ? (
          <>
            <button onClick={() => handleNonArmexSave(station.station_id)}>Uložit</button>
            <button onClick={() => setEditingNonArmexId(null)}>Zrušit</button>
          </>
        ) : (
          <>
          {canEditNearby && (
          <button  className={!active ? "btn-disabled" : ""} onClick={() => handleNonArmexEditClick(station)}>Změnit</button>
        )}
        {canPairNearbyToArmex && (
          <button
              onClick={() => {
                setAddingNONEStationToStation(station.station_id);
                setNewStationToStation({
                  stationId: '',
                  noneArmexStationId: station.station_id,
                  nonearmexstation_name: station.station_name,
                });
              }}
            >
              Přidat ČS stanice
            </button>
        )}
            </>
        )}

      </div>

      <div className="station-card__related">
        <strong>Přiřazená Armex Stanice:</strong>
        <div> 
      
        {(stations.find(st => st.station_id === station.station_id)?.connected_stations || []).map(s => (
            <li key={s.station_id || s.id}>
              {s.station_name || s.name}
              {canPairNearbyToArmex && (
              <button
                className="remove-station-button"
                onClick={() => handleRemoveStationStation(
                  s.station_id,
                  station.station_id,
                  s.name,
                  station.station_name
                )}
                title="Odebrat Armex stanici"
              >
                ✕
              </button>
              )}
            </li>

          ))}
          
          {isAssigningStationToNONEStation && (() => {
  const connectedIds = (station.connected_stations || []).map(s => Number(s.station_id));
  const availableStations = armexStations.filter(
    s => !connectedIds.includes(Number(s.station_id))
  );

  return (
    <div className="station-form">
      <select
        className="admin-select"
        onChange={(e) => {
          const selected = armexStations.find(
            s => s.station_id.toString() === e.target.value
          );

          setNewStationToStation({
            stationId: e.target.value, // selected ARMEX station is now the base
            noneArmexStationId: station.station_id, // current station is the target (non-Armex)
            nonearmexstation_name: station.station_name,
            armex_name: selected?.station_name || '',
          });
        }}
        defaultValue=""
        disabled={availableStations.length === 0}
      >
        {availableStations.length === 0 ? (
          <option value="">-- Všechny přiřazené stanice --</option>
        ) : (
          <>
            <option value="">-- Vyber Armex stanici --</option>
            {availableStations.map(s => (
              <option key={s.station_id} value={s.station_id}>
                {s.station_name}
              </option>
            ))}
          </>
        )}
      </select>

      <button
        className="admin-assign-button"
        onClick={StationToStationAssignment}
        disabled={availableStations.length === 0}
      >
        Přidat
      </button>
    </div>
  );
})()}



        </div>
      </div>
      {canEditandDisplayLimits && (
<div className="limits-inputs-div">
  
  <strong>Limity:</strong>

{(() => {
  const fuels = getStationLimitFuels(station);
  if (fuels.length === 0) {
    return <div className="muted">Žádné limity pro povolené povolené zboží.</div>;
  }
  return (
    <div className="limits-row">
      {fuels.map((fuel) => (
        <div key={fuel} className="limit-group">
        <span className="fuel-label">{fuel}</span>
        <div className="limit-inputs">
          <label>
            Min
 <input
  type="number"
  className="limits-input"
  value={getInputValue(station, station.station_id, fuel, "min")}
  onChange={(e) => {
    const value = e.target.value;
    setInputCache(prev => ({
      ...prev,
      [station.station_id]: {
        ...prev[station.station_id],
        [fuel]: {
          ...prev[station.station_id]?.[fuel],
          min: value
        }
      }
    }));
  }}
  onBlur={(e) => {
    const numericValue = parseFloat(e.target.value);
    handleLimitChange(
      fuel,
      station.station_id,
      "min",
      isNaN(numericValue) ? "" : numericValue
    );

    // Clear inputCache for this field
    setInputCache(prev => ({
      ...prev,
      [station.station_id]: {
        ...prev[station.station_id],
        [fuel]: {
          ...prev[station.station_id]?.[fuel],
          min: undefined
        }
      }
    }));
  }}
/>

          </label>
          <label>
            Max
                 <input
  type="number"
  className="limits-input"
  value={getInputValue(station, station.station_id, fuel, "max")}
  onChange={(e) => {
    const value = e.target.value;
    setInputCache(prev => ({
      ...prev,
      [station.station_id]: {
        ...prev[station.station_id],
        [fuel]: {
          ...prev[station.station_id]?.[fuel],
          max: value
        }
      }
    }));
  }}
  onBlur={(e) => {
    const numericValue = parseFloat(e.target.value);
    handleLimitChange(
      fuel,
      station.station_id,
      "max",
      isNaN(numericValue) ? "" : numericValue
    );

    // Clear inputCache for this field
    setInputCache(prev => ({
      ...prev,
      [station.station_id]: {
        ...prev[station.station_id],
        [fuel]: {
          ...prev[station.station_id]?.[fuel],
          max: undefined
        }
      }
    }));
  }}
/>
          </label>
        </div>
        
      </div>
      
      ))}

    </div>
  );
})()}
<div className="station-card__priceTypes">
  <strong>Povolené zboží:</strong>

 <div className="priceTypesChips">
  {(priceTypesCatalog || [])
    .filter(pt => pt.is_active)
    .map(pt => {
      const enabled = isStationPriceTypeEnabled(station, pt.id);
      const key = `${station.station_id}:${pt.id}`;
      const busy = !!ptBusy[key];

      return (
        <button
          type="button"
          key={pt.id}
          disabled={busy}
          onClick={() => togglePriceType(station, pt)}
          className={[
            "ptChip",
            enabled ? "ptChip--on" : "ptChip--off",
            busy ? "ptChip--busy" : "",
          ].join(" ")}
          title={enabled ? "Klikni pro zakázání" : "Klikni pro povolení"}
        >
          {pt.type_name}
        </button>
      );
    })}
</div>

  <div className="ptSummary">
    {(() => {
      const act = (priceTypesCatalog || []).filter(pt => pt.is_active);
      const enabledCount = act.filter(pt => isStationPriceTypeEnabled(station, pt.id)).length;
      return <span>{enabledCount}/{act.length} povoleno</span>;
    })()}
  </div>
</div>  
</div>

      )}
      {canDeactivateStation && (
      <div className='delete-station-div'>
          <button
            className={`delete-station-btn ${active ? "btn-danger" : "btn-ok"}`}
            onClick={() => toggleStationActive(station.station_id, station.station_name, station.is_active)}
          >
            {active ? "Deaktivovat" : "Aktivovat"}
          </button>
            </div>
            )}
    </div>
            
  );
})}

        </div>
      </div>
    </div>

   
    
  </div>



);


}